import { createActions } from '@/utils/actions';

const { actions: listings } = createActions('listings')
  .add('addListingPlaceholder')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('copyListings')
  .addAsync('deleteListings')
  .addAsync('getFilters')
  .addAsync('getListings')
  .addAsync('getStatuses')
  .addAsync('publishListings')
  .addAsync('schedulePublish')
  .add('setData')
  .add('setFilter')
  .add('setModal')
  .add('setOrder')
  .add('setPage')
  .add('setStatus')
  .addAsync('toggleListings')
  .add('toggleSidebarGroup')
  .add('toggleState');

export default listings;
